import _implicitStylesheets from "./loadingSpinner.css";
import _implicitScopedStylesheets from "./loadingSpinner.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="slds-col slds-align_absolute-center image-container${0}"${2}><img${"a1:src"}${"c1"}${"a1:alt"} width="202" height="222"${2}></div>`;
const $fragment2 = parseFragment`<div class="slds-col slds-align_absolute-center${0}"${2}><div class="spinner-container${0}"${2}><div role="status" class="slds-spinner slds-spinner_medium validating-spinner slds-spinner_brand${0}"${2}><span class="slds-assistive-text${0}"${2}>${"t4"}</span><div class="slds-spinner__dot-a${0}"${2}></div><div class="slds-spinner__dot-b${0}"${2}></div></div></div></div>`;
const $fragment3 = parseFragment`<div class="slds-col slds-align_absolute-center${0}"${2}><div class="title${0}"${2}>${"t2"}</div></div>`;
const $fragment4 = parseFragment`<div class="slds-col slds-align_absolute-center${0}"${2}><div class="description${0}"${2}>${"t2"}</div></div>`;
const stc0 = {
  classMap: {
    "loading-container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_vertical": true
  },
  key: 1
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, sp: api_static_part, st: api_static_fragment, d: api_dynamic_text, h: api_element} = $api;
  return [$cmp.showLoading ? api_element("div", stc0, [api_element("div", stc1, [$cmp.showImage ? api_static_fragment($fragment1, 3, [api_static_part(1, {
    className: api_normalize_class_name($cmp.imageCssClass),
    attrs: {
      "src": $cmp.image,
      "alt": $cmp.loadingText
    }
  }, null)]) : null, api_static_fragment($fragment2, 5, [api_static_part(4, null, api_dynamic_text($cmp.loadingText))]), $cmp.title ? api_static_fragment($fragment3, 7, [api_static_part(2, null, api_dynamic_text($cmp.title))]) : null, !$cmp.disableDescription ? api_static_fragment($fragment4, 9, [api_static_part(2, null, api_dynamic_text($cmp.loadingText))]) : null])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3i94csir565";
tmpl.legacyStylesheetToken = "appx-loadingSpinner_loadingSpinner";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
